export default __webpack_public_path__ + "static/media/logo-light.2281f476.png";